// test316
(316 && 0);
